import { createWorkflowAssignment } from './create'
import { deleteWorkflowAssignment } from './delete'
import { readWorkflowAssignment } from './read'
import { updateWorkflowAssignment } from './update'

export const workflowAssignments = {
  create: createWorkflowAssignment,
  delete: deleteWorkflowAssignment,
  readSingle: readWorkflowAssignment,
  update: updateWorkflowAssignment,
}
